import type { FaqItem } from "./types";

export const faqs: FaqItem[] = [
  {
    question: "91EatGossip 的爆料内容真实可靠吗？",
    answer: "91EatGossip 所有爆料内容均来自多方独立信源核实，我们与多位业内资深人士、工作室前员工、剧组工作人员保持长期合作关系。每条重大爆料均经过至少两个以上独立信源交叉验证，确保信息真实性。同时我们也欢迎读者提供线索，经核实后会第一时间发布。",
  },
  {
    question: "网站上的视频可以免费观看吗？",
    answer: "是的，91EatGossip 站内所有视频内容均可免费在线观看，无需注册会员或支付任何费用。我们坚持'吃瓜自由'的理念，让每一个关注娱乐八卦的用户都能零门槛获取最新资讯。部分高清独家视频可能需要关注我们的社交媒体账号解锁。",
  },
  {
    question: "如何确保不会错过最新爆料？",
    answer: "建议您将本站加入浏览器书签，我们每天7x24小时不间断更新。同时您也可以关注我们的站内动态与订阅入口，重大爆料会同步推送。本站首页的'热点追踪'板块会实时显示正在发酵的事件进展，确保您始终掌握第一手资讯。",
  },
  {
    question: "91EatGossip 的最新地址在哪里？",
    answer: "由于行业特殊性，我们的域名可能会不定期更换。为确保您始终能访问本站，强烈建议收藏本页面并关注我们的官方社交媒体账号。每次地址变更时，我们会通过所有官方渠道第一时间通知用户。您也可以在搜索引擎搜索'91EatGossip 最新地址'获取当前可用入口。",
  },
  {
    question: "可以向你们提供爆料线索吗？",
    answer: "当然可以！我们欢迎任何可靠的爆料线索。您可以通过页面底部的联系方式与我们取得联系，也可以发送邮件至我们的爆料邮箱。为保护爆料人隐私，我们承诺对所有信息来源严格保密，并可以根据您的要求以匿名方式发布相关内容。",
  },
  {
    question: "网站上的广告会影响阅读体验吗？",
    answer: "我们严格控制广告数量和形式，首页和文章页仅展示少量优质广告，绝不会出现弹窗、强制跳转等影响阅读体验的广告形式。我们的原则是：内容第一，广告第二。如果您遇到任何不良广告，欢迎通过反馈渠道告知我们。",
  },
];
